import {
  FETCH_RECRUITER_DETAILS_REQUEST,
  FETCH_RECRUITER_DETAILS_SUCCESS,
  FETCH_RECRUITER_DETAILS_FAILURE,
} from "./action";

const initialState = {
  loading: false,
  error: null,
  recruiterDetails: null,
};
const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_RECRUITER_DETAILS_REQUEST:
      return { ...state, loading: true, recruiterDetails: null, error: null };
    case FETCH_RECRUITER_DETAILS_SUCCESS:
      return { ...state, loading: false, recruiterDetails: action.payload, error: null };
    case FETCH_RECRUITER_DETAILS_FAILURE:
      return { ...state, loading: false, recruiterDetails: null, error: action.payload };
    default:
      return state;
  }
};

export default rootReducer;
